module.exports = __webpack_public_path__ + "assets/img/fa.790a72e9.png";